/**
 * Product More Section Logic
 * Handles Swiper initialization and section lifecycle events
 */

const SECTION_SELECTOR = '[data-section-id]';

class ProductMore extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    // Evitar inicialización duplicada
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    const sliderElement = this.querySelector('[data-product-more-swiper]');
    if (!sliderElement || !window.Swiper) return;

    const nextButton = this.querySelector('[data-slider-next]');
    const prevButton = this.querySelector('[data-slider-prev]');
    const scrollbarElement = this.querySelector('[data-slider-scrollbar]');

    const breakpoints = {
      640: {
        slidesPerView: 2,
        spaceBetween: 16
      },
      901: {
        slidesPerView: 4,
        spaceBetween: 16
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16
      }
    };

    /** @type {any} */
    const swiperOptions = {
      slidesPerView: 2,
      spaceBetween: 12,
      speed: 550,
      watchOverflow: true,
      breakpoints: breakpoints
    };

    if (nextButton && prevButton) {
      swiperOptions.navigation = {
        nextEl: nextButton,
        prevEl: prevButton
      };
    }

    if (scrollbarElement) {
      swiperOptions.scrollbar = {
        el: scrollbarElement,
        draggable: true,
        dragSize: 'auto'
      };
    }

    this.swiper = new window.Swiper(sliderElement, swiperOptions);
    
    // Refresh para asegurar métricas de scrollbar ok tras inicialización
    requestAnimationFrame(() => {
      if (this.swiper && this.swiper.scrollbar) {
        this.swiper.update();
        if (this.swiper.scrollbar.updateSize) this.swiper.scrollbar.updateSize();
        if (this.swiper.scrollbar.setTranslate) this.swiper.scrollbar.setTranslate();
      }
    });
  }
}

if (!customElements.get('product-more')) {
  customElements.define('product-more', ProductMore);
}
